import PropTypes from 'prop-types';
import { Icon } from '@iconify/react';
import searchFill from '@iconify/icons-eva/search-fill';
import roundFilterList from '@iconify/icons-ic/round-filter-list';
// material
import { useTheme, styled } from '@mui/material/styles';
import {
  Box,
  Toolbar,
  Tooltip,
  IconButton,
  Typography,
  OutlinedInput,
  InputAdornment,
  TextField,
  Menu,
  MenuItem
} from '@mui/material';
import { useEffect, useState } from 'react';
import FiltroRangoFecha from '../../../filtros/FiltroRangoFecha';
import DialogReporte from './reporte/DialogReporte';
import ReporteExcelButton from '../../../atomos/ReporteExcelButton';
import FiltroFechas from '../../../atomos/FiltroFechas';
import PedirReporteBackendButton from '../../../atomos/PedirReporteBackendButton';
import FiltroQuincenas from '../../../atomos/FiltroQuincenas';

// ----------------------------------------------------------------------

const STATUS_LIST = [
  { status: null, etiqueta: 'Todos' },
  { status: 'QUOTE', etiqueta: 'Cotización' },
  { status: 'LABEL_CREATED', etiqueta: 'Guía creada' },
  { status: 'CANCELADO', etiqueta: 'Cancelados' },
  { status: 'PENDIENTE-CANCELACION', etiqueta: 'Pendiente cancelación' }
];

const RootStyle = styled(Toolbar)(({ theme }) => ({
  height: 96,
  display: 'flex',
  justifyContent: 'space-between',
  padding: theme.spacing(0, 1, 0, 3)
}));

const SearchStyle = styled(OutlinedInput)(({ theme }) => ({
  width: 240,
  transition: theme.transitions.create(['box-shadow', 'width'], {
    easing: theme.transitions.easing.easeInOut,
    duration: theme.transitions.duration.shorter
  }),
  '&.Mui-focused': { width: 320, boxShadow: theme.customShadows.z8 },
  '& fieldset': {
    borderWidth: `1px !important`,
    borderColor: `${theme.palette.grey[500_32]} !important`
  }
}));

// ----------------------------------------------------------------------

const empaqValues = [
  { value: 'todos', label: 'Todos' },
  { value: 'con_empaque', label: 'Empaque' },
  { value: 'sin_empaque', label: 'Sin emapque' }
];

EnvioListToolbar.propTypes = {
  numSelected: PropTypes.number,
  filterName: PropTypes.string,
  onFilterName: PropTypes.func
};

export default function EnvioListToolbar({
  numSelected,
  filterName,
  onFilterName,
  handleStatus,
  handleEmpaqueVal,
  dataList,
  usersList,
  onDesdeDate,
  onHastaDate,
  handleResetFechas,
  hasReporte = false,
  hasReporteExcel = false,
  desdeDate,
  hastaDate,
  statusEnvioSelected,
  hasFiltroQuincena = false,
  sinDefaulDateFilter
}) {
  const theme = useTheme();
  const isLight = theme.palette.mode === 'light';

  useEffect(() => {
    if (sinDefaulDateFilter) {
      handleResetFechas();
    }
  }, []);

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [selectedStatuses, setSelectedStatuses] = useState(['LABEL_CREATED']);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleSelectStatus = (status) => {
    if (status === null) {
      setSelectedStatuses([]);
      handleStatus([]);
    } else {
      const isSelected = selectedStatuses.includes(status);
      let updatedSelectedStatuses;
      if (isSelected) {
        updatedSelectedStatuses = selectedStatuses.filter((s) => s !== status);
      } else {
        updatedSelectedStatuses = [...selectedStatuses, status];
      }
      setSelectedStatuses(updatedSelectedStatuses);
      handleStatus(updatedSelectedStatuses);
    }
  };

  // const getResult = (result) => {
  //   console.log('el resultado -----------------------------------', result);
  // };

  return (
    <RootStyle
      sx={{
        ...(numSelected > 0 && {
          color: isLight ? 'primary.main' : 'text.primary',
          bgcolor: isLight ? 'primary.lighter' : 'primary.dark'
        })
      }}
    >
      {numSelected > 0 ? (
        <Typography component="div" variant="subtitle1">
          {numSelected} selected
        </Typography>
      ) : (
        <SearchStyle
          value={filterName}
          onChange={onFilterName}
          placeholder="Buscar Paquete..."
          startAdornment={
            <InputAdornment position="start">
              <Box component={Icon} icon={searchFill} sx={{ color: 'text.disabled' }} />
            </InputAdornment>
          }
        />
      )}

      <FiltroFechas
        onDesdeDate={onDesdeDate}
        onHastaDate={onHastaDate}
        handleResetFechas={handleResetFechas}
        desdeDate={desdeDate}
        hastaDate={hastaDate}
      />
      {hasFiltroQuincena && (
        <FiltroQuincenas
          onDesdeDate={onDesdeDate}
          onHastaDate={onHastaDate}
          handleResetFechas={handleResetFechas}
          desdeDate={desdeDate}
          hastaDate={hastaDate}
        />
      )}
      {hasReporte && (
        <PedirReporteBackendButton
          intervaloReporte={{ date_from: desdeDate, date_to: hastaDate }}
          status={statusEnvioSelected}
        />
      )}
      {hasReporteExcel && !hasReporte && dataList && usersList && (
        <ReporteExcelButton dataList={dataList} usersIdList={usersList} />
      )}

      <Box sx={{ display: 'flex', gap: '10px' }}>
        <TextField
          id="outlined-select-currency"
          onChange={(e) => handleEmpaqueVal(e.target.value)}
          select
          label="Empaque"
          defaultValue="todos"
        >
          {empaqValues.map((val, i) => (
            <MenuItem key={i} value={val.value}>
              {val.label}
            </MenuItem>
          ))}
        </TextField>
      </Box>
      {handleStatus && (
        <>
          <Tooltip title="Estado de envio">
            <IconButton
              id="basic-button"
              aria-controls={open ? 'basic-menu' : undefined}
              aria-haspopup="true"
              aria-expanded={open ? 'true' : undefined}
              onClick={handleClick}
            >
              <Icon icon={roundFilterList} />
            </IconButton>
          </Tooltip>
          <Menu
            id="basic-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            MenuListProps={{
              'aria-labelledby': 'basic-button'
            }}
          >
            {STATUS_LIST.map(({ status, etiqueta }) => (
              <Box
                key={status}
                onClick={() => handleSelectStatus(status)}
                display="flex"
                sx={{ justifyContent: 'flex-start', alignItems: 'center', px: 2 }}
              >
                <Icon
                  icon={
                    (status === null && selectedStatuses.length === 0) || selectedStatuses.includes(status)
                      ? 'material-symbols:check'
                      : 'material-symbols:check-box-outline-blank'
                  }
                />
                <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                  <MenuItem onClick={() => handleStatus(status)}>{etiqueta}</MenuItem>
                </Box>
              </Box>
            ))}
          </Menu>
        </>
      )}
    </RootStyle>
  );
}
